import { FC, useEffect, useState } from 'react';
import { useDatePicker } from 'shared/lib/datepicker';
import { Container, DateContainer, Image, MaginLeft } from './styles';
import { CalendarDatePicker } from '../calendarDatePicker/calendarDatePicker/calendarDatePicker';
import { DatePickerRangeProps, TDay } from 'shared/types';
import { formatWithLocale } from 'shared/lib/datepicker/helpers/dateHelper';
import { Flex } from 'shared/ui/flex';
import calendarIcon from 'assets/icons/calendar-icon.svg';
import { Typography } from 'shared/ui/typography';

export const DatePickerRange: FC<DatePickerRangeProps> = ({
	selectRange,
	defaultRange,
}) => {
	const [selectedDate, setSelectedDate] = useState<TDay>(new Date());

	const {
		daysRange,
		daysRangeInput,
		isOpenCalendar,
		timeRange,
		openCalendar,
		selectDaysRangeAndCloseCalendar,
		modifyTimeInDaysRange,
		setDaysRangeInput,
	} = useDatePicker({ selectRange, selectedDate, setSelectedDate });

	useEffect(() => {
		if (defaultRange) {
			setDaysRangeInput(defaultRange);
		}
	}, [defaultRange, setDaysRangeInput]);

	return (
		<Container>
			<Flex $gap="3px" onClick={!window.matchMedia("(pointer: coarse)").matches ? openCalendar : undefined} onTouchStart={openCalendar} $alignItems="center">
				<DateContainer>
					<Flex
						$gap="4px"
						$height="100%"
						$cursor="pointer"
						role="date-input"
						className="date-picker"
            $alignItems='center'
					>
						<Image role="image" src={calendarIcon} />
						<Typography pointer>
							{formatWithLocale(
								daysRangeInput?.from,
								'dd MMMM yyyy HH:mm',
							)}
						</Typography>
					</Flex>
				</DateContainer>
				<span>&ndash;</span>
				<DateContainer>
					<Flex
						$gap="4px"
						$height="100%"
						$cursor="pointer"
						role="date-input"
						className="date-picker"
            $alignItems='center'
					>
						<Image role="image" src={calendarIcon} />
						<Typography pointer>
							{formatWithLocale(
								daysRangeInput?.to,
								'dd MMMM yyyy HH:mm',
							)}
						</Typography>
					</Flex>
				</DateContainer>
			</Flex>
			<MaginLeft>
				<CalendarDatePicker
					mode="range"
					selectedRange={daysRange}
					onSelectRange={selectDaysRangeAndCloseCalendar}
					isOpenCalendar={isOpenCalendar}
					timePicker={{
						onTimeChange: modifyTimeInDaysRange,
						timeRange,
					}}
				/>
			</MaginLeft>
		</Container>
	);
};
